/*
 * @Author: luting
 * @Date: 2022-04-15 16:33:21
 * @lastEditors: luting
 * @LastEditTime: 2022-05-12 10:17:05
 */
import {
  GET_DISKDATA,
  UPDATE_DISKDATA,
  GET_DISKID,
  FILTER_RECORD,
  GET_VISIBLE,
  UPDATE_RECORD,
  GET_RECORD,
} from '../constant';
import { diskConfigType } from 'root/pages/Guide/diskTypes';

const getDiskData = (payload: { confirmDiskData: diskConfigType[] }) => ({
  type: GET_DISKDATA,
  payload,
});

const updateDiskData = (payload: { id: number; size: number; index: number }) => ({
  type: UPDATE_DISKDATA,
  payload,
});

const getDiskId = (payload: { id?: number; acitveKey?: string }) => ({
  type: GET_DISKID,
  payload,
});

const filterRecord = (payload: { id: number }) => ({
  type: FILTER_RECORD,
  payload,
});

const getVisible = (payload: { visible: boolean }) => ({
  type: GET_VISIBLE,
  payload,
});

const updateRecord = (payload: { size: number; index: number }) => ({
  type: UPDATE_RECORD,
  payload,
});

const getRecord = (payload: { record: diskConfigType }) => ({
  type: GET_RECORD,
  payload,
});

export const disk = {
  getDiskData,
  updateDiskData,
  getDiskId,
  filterRecord,
  getVisible,
  updateRecord,
  getRecord,
};
